<h1 class="accessibility-only">Badges</h1>

<fgb-badges-nav></fgb-badges-nav>
<div class="container mt-4">
  <fgbcl-badge-overview-list [phaseThree]="true" [showPlaceholder]="true"></fgbcl-badge-overview-list>
</div>
